import React from 'react';

// Labeled on/off toggle row used across fabric dialogs
export const SwitchToggle = ({ label, hint, checked, onToggle, onColor = 'bg-green-500', testId }) => (
  <div className="flex items-center justify-between">
    <div>
      <span className="text-sm font-medium">{label}</span>
      {hint && <p className="text-xs text-neutral-500">{hint}</p>}
    </div>
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      data-state={checked ? 'checked' : 'unchecked'}
      data-testid={testId}
      onClick={onToggle}
      className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${checked ? onColor : 'bg-neutral-300'}`}
    >
      <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${checked ? 'translate-x-6' : 'translate-x-1'}`} />
    </button>
  </div>
);

export default SwitchToggle;
